import { createContext, ReactNode, useContext, useMemo, useState } from 'react';

interface EmployeeAvatarState {
  employeeAvatarRefreshToken: number;
  lastUpdatedEmployeeId?: string;
  notifyEmployeeAvatarUpdated: (employeeId: string) => void;
}

const EmployeeAvatarContext = createContext<EmployeeAvatarState | undefined>(undefined);

export const EmployeeAvatarProvider = ({ children }: { children: ReactNode }) => {
  const [employeeAvatarRefreshToken, setEmployeeAvatarRefreshToken] = useState(0);
  const [lastUpdatedEmployeeId, setLastUpdatedEmployeeId] = useState<string>();

  const value = useMemo<EmployeeAvatarState>(
    () => ({
      employeeAvatarRefreshToken,
      lastUpdatedEmployeeId,
      notifyEmployeeAvatarUpdated: (employeeId: string) => {
        setLastUpdatedEmployeeId(employeeId);
        setEmployeeAvatarRefreshToken(current => current + 1);
      }
    }),
    [employeeAvatarRefreshToken, lastUpdatedEmployeeId]
  );

  return <EmployeeAvatarContext.Provider value={value}>{children}</EmployeeAvatarContext.Provider>;
};

export const useEmployeeAvatar = () => {
  const context = useContext(EmployeeAvatarContext);
  if (!context) {
    throw new Error('useEmployeeAvatar must be used within an EmployeeAvatarProvider');
  }

  return context;
};
